import ProformaLayout from '../components/ProformaLayout.vue';
import ProformaList from '../components/ProformaList.vue';
import Proforma from '../components/Proforma.vue';

const proformaRoutes = [
  {
    path: 'proforma',
    props: true,
    // props: ({params}) => ({callId:+params.callId}),
    component: ProformaLayout,
    children: [
      {
        name: 'proformaList',
        path: '',
        props: (route: any) => ({
          location: 'portcall',
          callId: route.params.callId,
        }),
        component: ProformaList,
      },
      {
        name: 'proformaItem',
        path: ':proformaId',
        props: (route: any) => ({
          location: 'portcall',
          callId: route.params.callId,
          proformaId: route.params.proformaId,
        }),
        component: Proforma,
      },
    ],
  },
];

export default proformaRoutes;
